export const popularLocations = [
  "Tel Aviv",
  "Center",
  "Haifa",
  "Jerusalem",
  "North",
  "South",
  "Israel",
];

export const popularCategories = [
  "party",
  "techno",
  "house",
  "trance",
  "live music",
  "hiphop",
  "standup",
  "singles",
  "pool-party",
  "sexuality",
  "movement",
  "sports",
  "theater",
  "talk",
];
